import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faHome } from '@fortawesome/free-solid-svg-icons';

library.add(faCoffee, faHome);
